
import { useCallback, useState } from "react";
import { Node, Edge } from "@xyflow/react";
import { NodeData } from "../initial-nodes";

export function useDiagramPanels() {
  const [selectedNode, setSelectedNode] = useState<Node<NodeData> | null>(null);
  const [showNodePanel, setShowNodePanel] = useState(false);
  const [selectedEdge, setSelectedEdge] = useState<Edge | null>(null);
  const [showEdgePanel, setShowEdgePanel] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<Node<NodeData> | null>(null);
  const [showGroupPanel, setShowGroupPanel] = useState(false);
  const [selectedActor, setSelectedActor] = useState<Node<NodeData> | null>(null);
  const [showActorPanel, setShowActorPanel] = useState(false);

  const openNodePanel = useCallback((node: Node<NodeData>) => {
    // Create a clean copy of the node to avoid any reactivity issues
    const nodeCopy = JSON.parse(JSON.stringify(node));
    setSelectedNode(nodeCopy);
    setShowNodePanel(true);
  }, []);

  const openEdgePanel = useCallback((edge: Edge) => {
    // Create a clean copy of the edge to avoid any reactivity issues
    const edgeCopy = JSON.parse(JSON.stringify(edge));
    setSelectedEdge(edgeCopy);
    setShowEdgePanel(true);
  }, []);

  const openGroupPanel = useCallback((node: Node<NodeData>) => {
    // Create a clean copy of the node to avoid any reactivity issues
    const nodeCopy = JSON.parse(JSON.stringify(node));
    setSelectedGroup(nodeCopy);
    setShowGroupPanel(true);
  }, []);

  const closeNodePanel = useCallback(() => {
    setShowNodePanel(false);
    // Use a slight delay to prevent UI flickering
    setTimeout(() => {
      setSelectedNode(null);
    }, 100);
  }, []);

  const closeEdgePanel = useCallback(() => {
    setShowEdgePanel(false);
    // Use a slight delay to prevent UI flickering
    setTimeout(() => {
      setSelectedEdge(null);
    }, 100);
  }, []);

  const closeGroupPanel = useCallback(() => {
    setShowGroupPanel(false);
    // Use a slight delay to prevent UI flickering
    setTimeout(() => {
      setSelectedGroup(null);
    }, 100);
  }, []);

  const openActorPanel = useCallback((node: Node<NodeData>) => {
    // Create a clean copy of the node to avoid any reactivity issues
    const nodeCopy = JSON.parse(JSON.stringify(node));
    setSelectedActor(nodeCopy);
    setShowActorPanel(true);
  }, []);

  const closeActorPanel = useCallback(() => {
    setShowActorPanel(false);
    // Use a slight delay to prevent UI flickering
    setTimeout(() => {
      setSelectedActor(null);
    }, 100);
  }, []);

  return {
    selectedNode,
    showNodePanel,
    openNodePanel,
    closeNodePanel,
    selectedEdge,
    showEdgePanel,
    openEdgePanel,
    closeEdgePanel,
    selectedGroup,
    showGroupPanel,
    openGroupPanel,
    closeGroupPanel,
    selectedActor,
    showActorPanel,
    openActorPanel,
    closeActorPanel,
    setSelectedNode,
    setSelectedEdge,
    setSelectedGroup,
    setSelectedActor
  };
}
